import { TFunction } from 'i18next';

export const getMergeVideoSourceTabs = (t: TFunction) => ({
  library: {
    value: t('Library'),
    isHidden: false,
    isLocked: false,
    isDisabled: false,
    isLive: true,
  },
  wheelsTv: {
    value: t('WheelsTV'),
    isHidden: false,
    isLocked: false,
    isDisabled: false,
    isLive: true,
  },
  lesa: {
    value: t('Lesa'),
    isHidden: false,
    isLocked: false,
    isDisabled: false,
    isLive: true,
  },
  organizationVideo: {
    value: t('OEM'),
    isHidden: true, // hide by default and show if has any organization videos
    isLocked: false,
    isDisabled: false,
    isLive: true,
  },
  vinReels: {
    value: t('VIN Reels'),
    isHidden: false,
    isLocked: false,
    isDisabled: false,
    isLive: true,
  },
});
